import { FC, memo } from 'react';

import { Select } from '@keaze/web/components/select';
import { Checkboxes } from '@keaze/web/components/filters';
import { Group } from '../groups';
import { setEmptySelectValue } from '../helpers/setEmptySelectValue';
import { renderMenuItemSelect } from '../helpers';
import { MoreFiltersProps } from './moreFilters.types';
import styled from 'styled-components';

type GenerateOnClearPropArgs = {
  filterValue: any;
  param: string;
  onClear?: (name: string) => void;
};

type GenerateOnClearPropExpected = {
  onClear?: () => void;
};

type GenerateOnClearProp = (
  args: GenerateOnClearPropArgs
) => GenerateOnClearPropExpected;

const S = {
  // This is a pragmatic Solution todo will refactor the rendering

  mobileFilters: styled.div`
    .max_deposit,
    .max_full_value,
    max_full_value,
    .bathrooms,
    .parking,
    .new_homes,
    .schemes,
    .status,
    .new_homes,
    .other_features {
      display: none;
    }

    p {
      ${({ theme: { colors } }) => `
    color: ${colors.whites.white1} !important;
    `}
    }

    .Mui-checked {
      svg {
        ${({ theme: { colors } }) => `
  fill: ${colors.whites.white1} !important ;
  `}
      }
    }
  `,
};

const generateOnClearProp: GenerateOnClearProp = ({
  filterValue,
  param,
  onClear,
}) => {
  if (!onClear || !filterValue || filterValue.length === 0) {
    return {};
  }

  return {
    onClear: () => onClear(param),
  };
};

export const MoreFilters: FC<MoreFiltersProps> = memo(
  ({ data, onChange, onClear }) => (
    <S.mobileFilters>
      {data.map(({ param, name, multiValue, options, value }) => {
        if (multiValue) {
          return (
            <div className={param}>
              <Group key={param} title={name}>
                <Checkboxes
                  name={param}
                  value={value as number[]}
                  data={options}
                  onChange={onChange}
                />
              </Group>
            </div>
          );
        }

        return (
          <div className={param}>
            <Group
              key={param}
              title={name}
              {...generateOnClearProp({
                filterValue: value,
                param,
                onClear,
              })}
            >
              <Select
                name={param}
                value={setEmptySelectValue(value as number[])}
                data={options}
                renderMenuItem={renderMenuItemSelect}
                onChange={({ target: { name, value } }) =>
                  onChange(name as string, value as string)
                }
              />
            </Group>
          </div>
        );
      })}
    </S.mobileFilters>
  )
);
